import React, {useEffect, useMemo, useState} from "react";
import {isSuccess} from "api/request";
import {Button, ModalWithHeader, Field, Input} from "components"
import {bindCexApi} from "../../api";
import {CEXType, ModalWithHeaderProps} from "../../types/types";
import {FormattedMessage, useIntl} from "react-intl";
import {useUserInfo} from "../../hooks";
import eventManager from "../../hooks/eventManager";
import {useMatch} from "../../MatchContext";

export default function CEXBindModal({
                                         onClose,
                                         type,
                                         isOpen = false,
                                         ...props
                                     }: {
    type: CEXType | '',
    onClose: () => void,
} & ModalWithHeaderProps) {
    const intl = useIntl()
    const {events} = useMatch()

    const [APIPassphrase, setAPIPassphrase] = useState<string>('')
    const {refreshOverview} = useUserInfo()
    const [loading, setLoading] = useState<boolean>(false)
    const [key, setKey] = useState<string>('')
    const [secret, setSecret] = useState<string>('')
    const [error, setError] = useState<string>('')
    const needPassphrase = useMemo(()=>{
        return ['bitget','okx'].includes(type.toLowerCase())
    },[type])
    useEffect(() => {
        if (isOpen) {
            setSecret('')
            setKey('')
            setAPIPassphrase('')
            setError('')
            setLoading(false)

        }
    }, [isOpen]);

    const SubmitApi = async () => {
        try {
            setLoading(true)
            const res = await bindCexApi({
                cex: type,
                api_key: key,
                api_secret: secret,
                ...(needPassphrase ? {api_passphrase: APIPassphrase} : {})
            });
            if (isSuccess(res)) {

                await refreshOverview()
                events!.onBind && events!.onBind({
                    type: 'cex_' + type
                })
                eventManager.emit('onBind', {
                    type: 'cex_' + type
                })
                onClose()
            }else{
                throw new Error(res.message)
            }


        } catch (error: any) {
            console.error(error)
            setError(error.message)
        }finally {
            setLoading(false)
        }
    }
    return <ModalWithHeader showClose isOpen={isOpen} onClose={onClose} title={intl.formatMessage({
        id: "CEXBindTitle"
    }, {
        type
    })} {...props}>
        <div className={"matchid-cex-modal"}>
            <div>
                <p><FormattedMessage id="CEXBindAttention"/></p>
                <p><FormattedMessage id="CEXBindTips1"/></p>
                <p><FormattedMessage id="CEXBindTips2"/></p>
                <p><FormattedMessage id="CEXBindTips3"/></p>
            </div>
            <Field label={intl.formatMessage({
                id: "CEXBindApiKey"
            })}>
                <Input value={key}
                       onChange={(e) => setKey(e.target.value)}
                       placeholder='**** **** ****'
                />
            </Field>
            <Field label={intl.formatMessage({
                id: "CEXBindApiSecretKey"
            })} error={!needPassphrase && error}>
                <Input value={secret}
                       onChange={(e) => setSecret(e.target.value)}
                       placeholder='**** **** ****'
                />
            </Field>
            {
                needPassphrase && <Field error={error} label={intl.formatMessage({
                    id: "CEXBindApiPassphrase"
                })}>
                    <Input value={APIPassphrase}
                           onChange={(e) => setAPIPassphrase(e.target.value)}
                           placeholder='**** **** ****'
                    />
                </Field>
            }
            <Button onClick={SubmitApi} size="lg" block loading={loading}
                    disabled={!key || !secret}><FormattedMessage id={"continue"}/></Button>

        </div>

    </ModalWithHeader>
}